import axios from 'axios';

export const requestsRejectedApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/requests-rejected`,
    headers: {
        'Content-Type': 'application/json'
    }
})